import { useState } from "react"
import { Input } from "antd"
import "../assets/styles/FloatingInput.css"

/**
 * An input component with a floating label.
 *
 * @param {Object} props - Component props
 * @param {string} props.label - The label text
 * @param {string} props.value - The input value
 * @param {Function} props.onChange - Function called when input changes
 * @param {string} props.name - The input name attribute
 * @param {string} props.type - The input type (default: "text")
 * @param {string} props.error - Error message
 * @param {boolean} props.touched - Whether the field has been touched
 * @param {boolean} props.required - Whether the field is required
 * @param {boolean} props.disabled - Whether the field is disabled
 * @returns {JSX.Element} The FloatingInput component
 */
const FloatingInput = ({
  label,
  value,
  onChange,
  name,
  type = "text",
  error,
  touched,
  required,
  disabled,
  ...props
}) => {
  const [isFocused, setIsFocused] = useState(false)

  return (
    <div
      className={`floating-input ${isFocused || value ? "focused" : ""} ${error && touched ? "error" : ""} ${required ? "required" : ""} ${disabled ? "disabled" : ""}`}
    >
      <Input
        value={value}
        onChange={onChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        name={name}
        type={type}
        placeholder=" "
        disabled={disabled}
        {...props}
      />
      <label>
        {label}
        {required && "*"}
      </label>
    </div>
  )
}

export default FloatingInput